import { apiClient } from "../api/ApiClient";
import type { Supplier } from "../models/Supplier";
import type { KeyValue } from "../models/KeyValue";
import { CreateCrudService } from "./CrudServiceFactory";
export function SupplierService() {
  return CreateCrudService<Supplier, KeyValue>({
    PaginationInPath: true,
    SaveRequest: async (rows) =>
      (
        await apiClient.post<Supplier[]>(
          "supplier/SaveSupplier",
          rows.map((row) => {
            const { PhoneNumber, ...supplier } = row as Supplier & {
              PhoneNumber?: string;
            };
            return supplier;
          }),
        )
      ).data,
    Route: "supplier",
    EntityName: "Supplier",
    DeleteAction: "DeleteSupplier",
    PartialFields: ["Code", "Name"],
    LoadingMessage: "Loading supplier records...",
    SavingMessage: "Saving supplier...",
    MapPartial: (x) => ({
      Key: String(x.Code ?? ""),
      Value: String(x.Name ?? x.Code ?? ""),
    }),
  });
}
